export default __webpack_public_path__ + "static/media/parallax-bg36.8b1e3f85.jpg";